import styled from 'styled-components/native';

// Layout da coluna de comentários.
//
// Cores ficam nos componentes (dependem do `customColor` do cliente e precisam
// de `hexToRgba` para derivar borda/superfície); aqui mora só a geometria.
//
// Medidas em px, não rem: no React Native Web o rem depende do font-size da
// raiz, então o mesmo valor rendia espaçamentos diferentes entre a coluna do
// desktop e o bloco do mobile.

// No DESKTOP a altura vem do pai (a coluna de 30% ao lado do vídeo) e a coluna
// se divide em três faixas: cabeçalho, lista rolável e campo de escrever colado
// embaixo. `min-height: 0` é o que deixa a lista encolher e rolar em vez de
// crescer para fora da tela.
//
// No CELULAR quem rola é a página inteira: o bloco cresce com o conteúdo
// (`flex: 0`, altura automática) e a rolagem própria não existe.
export const Container = styled.View`
  flex: ${({ scrolls }) => (scrolls ? 1 : 0)};
  min-height: 0;
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: baseline;
`;

export const CountBadge = styled.View`
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
`;

// Linha de um comentário ou de uma resposta.
export const ViewComment = styled.View`
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 0px;
`;

// Coluna de texto ao lado do avatar. `min-width: 0` é o que permite o
// `numberOfLines` do nome truncar em vez de empurrar a lixeira para fora.
export const CommentBody = styled.View`
  flex: 1;
  min-width: 0;
`;

export const CommentHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

// Bloco das respostas, indentado para alinhar com o texto do comentário pai
// (avatar de 36 + 12 de respiro, menos 4 para a linha de thread respirar).
export const RepliesGroup = styled.View`
  margin-left: 44px;
  padding-bottom: 8px;
`;

// Fio vertical que liga as respostas ao comentário — no lugar de repetir
// avatar grande e recuar tudo, que come a largura útil da coluna estreita.
// `top: 52px` = 12 de padding do ViewComment + 36 do avatar + 4 de respiro;
// `left: 17px` centra o fio de 2px sob um avatar de 36.
export const ThreadLine = styled.View`
  position: absolute;
  left: 17px;
  top: 52px;
  bottom: 8px;
  width: 2px;
  border-radius: 1px;
`;

// Campo de escrever, ancorado no rodapé da coluna.
export const Content = styled.View`
  flex-direction: row;
  align-items: flex-end;
  padding-top: 12px;
  margin-top: 8px;
  border-top-width: 1px;
`;

// Faixa "Respondendo a X" acima do campo, com o botão de sair do modo resposta.
export const ReplyingBanner = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 6px 10px;
  margin-bottom: 8px;
`;

// `flex: 1` só faz sentido quando a coluna tem altura própria (desktop): aí o
// estado vazio ocupa a faixa da lista e centraliza. No celular a altura é do
// conteúdo, então ele não pode esticar.
export const EmptyState = styled.View`
  flex: ${({ scrolls }) => (scrolls ? 1 : 0)};
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
`;
